module.exports = __webpack_public_path__ + "static/img/3-1-2.3a5aeb4d.jpg";